module.exports = __webpack_public_path__ + "img/GAME_COUNTCHICKS.6e12fc50.png";